import ModalAlert from '../../../../js/components/modalAlert/ModalAlert'
import messageResource from '../../../../js/messageResource'
import $ from '../../../../js/alias/jquery'
import {ModalAlertPointerPosition} from '../../../../js/components/modalAlert/constants'
import View from '../../../../js/View'
import {connect} from '../../../../js/redux/utils'
import {deleteFeed} from '../actions'
import {bindActionCreators} from 'redux'
import {isUserActionLoading} from '../selectors'

class ICalDeleteDialog extends View {
    constructor({
        deleteFeed = () => {},
    }) {
        super()

        this.state = {
            iCalSettingsId: 0,
            loading: false,
        }

        this.actions = {
            deleteFeed,
        }

        this.onStatePropertyChanged('loading', loading => this.modalAlert.setState({loading}))
    }

    afterRender() {
        this.modalAlert = new ModalAlert({
            showCancelButton: true,
            okButtonLabel: messageResource.getMessage('icalendar.dialog.delete.ok'),
            returnToInitialPosition: false,
            onConfirm: () => this.actions.deleteFeed(this.state.iCalSettingsId, () => this.modalAlert.hide()),
            withLoading: true,
        }).init($('body'))

        this.modalAlert.setState({
            header: messageResource.getMessage('icalendar.dialog.delete.header'),
            text: messageResource.getMessage('icalendar.dialog.delete.content'),
            additionalClass: 'iCalDeleteDialog',
            pointerPosition: ModalAlertPointerPosition.RIGHT,
            offsets: {
                left: 19,
                top: 0,
            },
        })
    }

    showAt(element, onHideCb) {
        this.modalAlert.showAt(element, onHideCb)
    }
}

const ICalDeleteDialogConnected = connect(
    state => ({
        loading: isUserActionLoading(state),
    }),
    dispatch => ({
        deleteFeed: bindActionCreators(deleteFeed, dispatch),
    })
)(ICalDeleteDialog)

let instance = null
export const getDeleteDialog = () => {
    if (!instance) {
        instance = new ICalDeleteDialogConnected().init()
    }
    return instance
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/dialogs/DeleteDialog.js